import { useState } from 'react'
import Fab from '@mui/material/Fab'
import WallpaperIcon from '@mui/icons-material/Wallpaper'
import ControlBarItem from '@/components/chime-sdk/controls/ControlBarItem'
import { BackgroundEffectModal } from './BackgroundEffectModal'

export function BackgroundControl() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpenModal = () => setIsModalOpen(true)
  const handleCloseModal = () => setIsModalOpen(false)

  return (
    <ControlBarItem>
      <Fab color="primary" onClick={handleOpenModal} size="small">
        <WallpaperIcon />
      </Fab>

      <BackgroundEffectModal open={isModalOpen} onClose={handleCloseModal} />
    </ControlBarItem>
  )
}
